export const figure13 = {
    chart: {
        type: 'line',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height:230,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
      },
      credits: {
        enabled: false
    },
      title: {
        text: 'Éthiopie'
      },
      subtitle: {
        text: null
    },
      xAxis: {
        categories: ['2014','2016','2019']
      },
      labels: {
        	
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      yAxis: {
        min: 0,
        max: 10,
        tickInterval: 5,
        title: {
            text: null,
        },
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: true
        }
    },
    legend: {
        enabled: false,
    },
    note: {
        enabled: false,
    },
      colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
      series: [{
        name: 'Petites exploitations',
        data: [3.9, 4.4, 4.9,]
      }, {
        name: 'Autres exploitations',
        data: [6.5, 6.1, 7.8,]
      },{
        name: 'Petites exploitations dirigées par une femme',
        data: [3.6, 5.0, 4.4,]
      },{
        name: 'Petites exploitations dirigées par un homme',
        data: [4.0, 4.2, 5.1,]
        }]
  
}


    